import { render } from "./BusinessElementsEdition.vue?vue&type=template&id=98c48138&scoped=true"
import script from "./BusinessElementsEdition.vue?vue&type=script&lang=js"
export * from "./BusinessElementsEdition.vue?vue&type=script&lang=js"

import "./BusinessElementsEdition.vue?vue&type=style&index=0&id=98c48138&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98c48138"]])

export default __exports__